import React from 'react';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import {
  ButtonContainer,
  StyleSummaryCardContainer,
  SummaryCardTitle,
  SummaryDataContainer,
  SummaryInfosContainer,
  SummaryInfosTextContainer,
  SummaryInfosTitlesContainer,
  SummaryActionsContainer,
} from './styled.previewSkeleton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export function PreviewSkeleton () {
  return (
    <>
      <StyleSummaryCardContainer>
        <SummaryCardTitle>
          <Skeleton width={120} />
        </SummaryCardTitle>
        <SummaryDataContainer>
          <Skeleton height={100} width={100} />
          <SummaryInfosContainer>
            <SummaryInfosTextContainer>
              <SummaryInfosTitlesContainer>
                <Skeleton width={80} />
                <Skeleton width={60} />
              </SummaryInfosTitlesContainer>
              <SummaryInfosTitlesContainer>
                <Skeleton width={80} />
                <Skeleton width={60} />
              </SummaryInfosTitlesContainer>
            </SummaryInfosTextContainer>
          </SummaryInfosContainer>
        </SummaryDataContainer>
        <SummaryActionsContainer>
          <Skeleton width={35} />
          <Skeleton height={15} width={15} />
        </SummaryActionsContainer>
      </StyleSummaryCardContainer>
      <ButtonContainer>
        <ButtonBlockColumn>
          <Skeleton height={48} borderRadius={8} />
          <Skeleton height={48} borderRadius={8} />
        </ButtonBlockColumn>
      </ButtonContainer>
    </>
  );
}
